<div class="container-fluid">
    <div class="row">
        <app-section-title title="TITLES.DEVICE-STATUS">
        </app-section-title>
    </div>
    <p>device-status works!</p>
</div>